var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDotsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 3,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.4,
  fill: "#ABABB2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2.407,
  height: 2.407,
  rx: 1.204
}), /*#__PURE__*/React.createElement("rect", {
  y: 5.296,
  width: 2.407,
  height: 2.407,
  rx: 1.204
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.593,
  width: 2.407,
  height: 2.407,
  rx: 1.204
}))));
export { SvgDotsIcon as ReactComponent };
export default __webpack_public_path__ + "903ba5c36a11314ed01c0ba85d5716f2.svg";